require('./bootstrap');

// Import the tracker (this will also import the Amplitude SDK)
import AmplitudeTracker from './amplitude'

// Create ONE global instance
window.amplitudeTracker = new AmplitudeTracker()

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    window.amplitudeTracker.init()
})
// Load before action.js — action can throw during init (e.g. plugin require); loading must still register.
require('./global-page-loading');
require('./action');
